"use strict";

import { swiffyslider } from 'swiffy-slider/dist/js/swiffy-slider.esm';
import { slideUp, slideDown, slideToggle } from "./functions.js";

window.swiffyslider = swiffyslider;
window.slideUp = slideUp;
window.slideDown = slideDown;
window.slideToggle = slideToggle;

document.addEventListener('DOMContentLoaded', function () {
  window.swiffyslider.init();

  const promoCardSuptext = document.querySelectorAll('.promo-card__suptext');
  if(promoCardSuptext) {
    promoCardSuptext.forEach((item) => {
      item.style.marginTop = - item.offsetHeight + 'px';
    })
  }

  const popupClose = document.querySelectorAll('.popup__close');
  if(popupClose) {
    popupClose.forEach((close) => {
      close.addEventListener('click', (e) => {
        e.target.parentNode.parentNode.classList.remove('popup--active');
        if( e.target.closest('.popup-demo__close') ) {
          document.querySelector('.popup-demo iframe').remove();
        }
      });
    });
  }

  const buttonsDataHref = document.querySelectorAll('[data-href]');
  if (buttonsDataHref.length) {
    [...buttonsDataHref].forEach((buttonDataHref) => {
      buttonDataHref.addEventListener('click', (e) => {
        let el = e.target.closest('[data-href]');
        const dataRef = el.getAttribute('data-href');
        window.open(dataRef, '_blank');
      });
    });
  }

  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  window.addEventListener('resize', () => {
    vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
});